<template>
  <div class="home cont_bg">
    <navs :lang="true" :saver="true" />
    <div v-if="Object.keys(homeData).length">
      <div class="swipe">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in homeData?.banner" :key="index">
            <img :src="assetUrl(item.image)" alt="">
          </van-swipe-item>
        </van-swipe>
        <div style="padding: 0 .3rem">
          <div class="cover_info">
            <!-- <div class="cover_info_item" v-for="(item, index) in cover_info" :key="index"
              @click="$router.push(item.to)">
              <div class="icon">
                <i class="material-icons">{{ item.desc }}</i>
              </div>
              <span>{{ item.title }}</span>
            </div> -->
            <!-- 开始赚钱 -->
            <div class="cover_info_item" @click="$router.push('/goOrder')">
              <div class="icon">
                <svg t="1748485965394" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  p-id="10595" width=".64rem">
                  <path fill="#fff"
                    d="M265.216 967.68c-7.68 0-15.36-3.072-21.504-8.704-10.24-9.728-12.288-25.088-5.632-37.888l171.008-303.616-179.712-159.232c-6.656-5.632-10.24-13.824-10.24-22.528 0-8.704 3.584-16.896 9.728-23.04l363.008-347.648c9.728-9.216 24.576-11.264 36.864-4.608 11.776 6.656 17.92 20.48 15.36 33.792l-65.024 303.616 215.552 204.8c7.168 6.656 10.752 16.384 9.728 25.6-1.024 9.728-6.656 18.432-14.848 23.04l-117.76 72.192c-14.336 8.704-33.792 4.608-42.496-10.24-8.704-14.848-4.096-33.792 10.24-42.496l82.432-51.2-198.656-188.416c-7.68-7.68-11.264-18.432-9.216-29.184l47.616-221.696-265.728 253.952 173.056 153.6c10.752 9.728 13.824 25.6 6.656 38.4l-124.416 220.672 151.552-93.184c14.336-9.216 33.792-4.608 42.496 10.24 9.216 14.336 4.608 33.792-10.24 42.496L281.6 963.072c-5.12 3.072-10.752 4.608-16.384 4.608z m0 0"
                    p-id="1661"></path>
                </svg>
              </div>
              <span>{{ $t('cover_info.t01') }}</span>
            </div>

            <!-- 充值金币 -->
            <div class="cover_info_item" @click="$router.push('/recharge')">
              <div class="icon">
                <svg t="1778141324205" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="24867" style="width: .64rem;height: .64rem;">
                  <path
                    d="M661.802667 149.333333a85.333333 85.333333 0 0 1 85.333333 85.333334v106.368H832a85.333333 85.333333 0 0 1 85.333333 85.333333V533.333333H853.333333V426.368a21.333333 21.333333 0 0 0-17.493333-20.992l-3.84-0.341333h-148.864V234.666667a21.333333 21.333333 0 0 0-17.493333-20.992L661.802667 213.333333H234.666667a64 64 0 0 0-63.701334 57.856L170.666667 277.333333v469.333334a64 64 0 0 0 57.856 63.701333L234.666667 810.666667h341.333333v64h-341.333333a128 128 0 0 1-128-128v-469.333334a128 128 0 0 1 128-128h427.136z"
                    fill="#ffffff" p-id="24868"></path>
                  <path
                    d="M170.666667 277.333333a64 64 0 0 0 57.856 63.701334L234.666667 341.333333H682.666667v64H234.666667a128 128 0 0 1-127.786667-120.490666L106.666667 277.333333H170.666667z"
                    fill="#ffffff" p-id="24869"></path>
                  <path
                    d="M885.333333 533.333333m-42.666666 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z"
                    fill="#ffffff" p-id="24870"></path>
                  <path
                    d="M810.666667 618.666667a32 32 0 0 1 32 32l-0.042667 64h64.042667a32 32 0 1 1 0 64h-64.042667l0.042667 64a32 32 0 1 1-64 0l-0.042667-64H714.666667a32 32 0 1 1 0-64h63.957333l0.042667-64a32 32 0 0 1 32-32z"
                    fill="#ffffff" p-id="24871"></path>
                  <path
                    d="M576 842.666667m-42.666667 0a42.666667 42.666667 0 1 0 85.333334 0 42.666667 42.666667 0 1 0-85.333334 0Z"
                    fill="#ffffff" p-id="24872"></path>
                </svg>
              </div>
              <span>{{ $t('cover_info.t02') }}</span>
            </div>
            <!-- 提现金币 -->
            <div class="cover_info_item" @click="$router.push('/withdraw')">
              <div class="icon">
                <svg t="1778141592039" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="31279" style="width: .64rem;height: .64rem;">
                  <path
                    d="M161.3 897.9c-25.4 0-50.9-11.3-71.7-31.8-18.6-18.3-29.7-45.7-29.7-73.3V265.3h0.2c1.4-23.8 11.3-44.9 29.5-62.9 18.2-17.9 43-27.3 71.7-27.3H308c15.5 0 28.1 12.5 28.1 27.8s-12.6 27.8-28.1 27.8H161.3c-14.6 0-24.8 3.3-32 10.5-8.9 8.7-13.2 18.5-13.2 30 0 12.5 5.1 25.3 13.2 33.3 9.6 9.5 21.3 14.9 32 14.9h733.2c19.8 0 34.7 5.3 45.7 16.1 13 12.7 19 26.2 19 42.6v450.8c0 17.9-7.3 36.2-19 47.8-13.9 13.7-30.1 21.2-45.7 21.2H161.3z m-45.2-105c0 12.7 5.2 26 13.2 33.9 5.9 5.8 17.9 15.6 32.1 15.6h733.1c1.6-0.5 4.9-3.8 6.2-5 1-1 2.5-5.1 2.5-8.4V378.1v-0.6c-0.3-0.5-1.4-1.6-2.3-2.4-0.3-0.1-0.8-0.1-2.1-0.1H161.3c-15.2 0-30.6-4.2-45.2-12.3v430.2z m503.5-19.4c-17.5 0-31.8-13.7-31.8-30.5s14.3-30.5 31.8-30.5h176c17.5 0 31.8 13.7 31.8 30.5s-14.3 30.5-31.8 30.5h-176zM305.3 267.8L588.4 97l0.4-0.2c8.9-4.3 18.8-6.6 28.8-6.6 7.7 0 15.3 1.3 22.5 4 16.5 6 29.9 18.6 36.9 34.4l92 157-52 21.5-91.3-155.7-0.2-0.6c-0.9-2.2-2.6-3.7-4.8-4.5-1-0.3-2-0.5-3-0.5-1.2 0-2.4 0.2-3.5 0.7L330.5 317.6l-25.2-49.8z m534.3 20.7c-15.5 0-28.1-12.5-28.1-27.8v-26.9-0.7c-0.3-0.5-1.4-1.6-2.3-2.4-0.3-0.1-0.8-0.1-2.1-0.1h-7.9c-15.5 0-28.1-12.4-28.1-27.7s12.6-27.8 28.1-27.8h3.7c19.8 0 34.8 5.3 45.8 16.1 13 12.7 19 26.2 19 42.6v26.9c0 15.4-12.6 27.8-28.1 27.8z"
                    fill="#ffffff" p-id="31280"></path>
                  <path
                    d="M933.4 342.4c-10.4-10.2-24.2-13.3-38.9-13.3H161.3c-14.7 0-28.5-7.6-38.9-17.8-10.4-10.2-16.1-25.8-16.1-40.2 0-14.5 5.7-26.7 16.1-37 10.4-10.2 24.2-13.3 38.9-13.3H308c10.1 0 18.3-8.1 18.3-18s-8.2-18.1-18.3-18.1H161.3c-24.5 0-47.5 7.5-64.8 24.5S69.7 247 69.7 271c0 1.3 0.3 2.6 0.4 3.9h-0.4v517.8c0 24.1 9.5 49.3 26.8 66.3s40.4 29 64.8 29h733.2c14.7 0 28.5-8.2 38.9-18.4s16.1-26.4 16.1-40.8V378.1c0.1-14.4-5.6-25.5-16.1-35.7z m-20.5 486.5c0 4.8-1.9 11.9-5.4 15.3-3.5 3.4-8.1 7.9-12.9 7.9H161.3c-14.7 0-28.5-8.2-38.9-18.4s-16.1-26.4-16.1-40.8V344.5c15.8 12.4 34.8 20.7 55 20.7h733.2c4.9 0 9.5-0.7 12.9 2.7 3.4 3.4 5.4 5.4 5.4 10.2l0.1 450.8zM799.2 221h3.7c4.9 0 9.5-0.7 13 2.7s5.4 5.4 5.4 10.2v26.9c0 9.9 8.2 18 18.4 18 10.1 0 18.3-8.1 18.3-18v-26.9c0-14.5-5.7-25.5-16.1-35.7-10.4-10.2-24.2-13.3-38.9-13.3h-3.7c-10.2 0-18.3 8.1-18.3 18.1-0.1 9.9 8.1 18 18.2 18z m-464.7 82.8l275-166c4.6-2.2 9.7-2.5 14.5-0.8s8.5 5.3 10.5 9.9l86.7 147.9 33.8-14-86.7-147.9c-5.9-13.7-17.4-24.5-31.5-29.7-14.2-5.2-30.1-4.4-43.6 2.2l-275 166 16.3 32.4z m461.1 418.5h-176c-12.2 0-22 9.3-22 20.8 0 11.4 9.8 20.8 22 20.8h176c12.2 0 22-9.3 22-20.8 0-11.6-9.9-20.8-22-20.8z"
                    fill="#ffffff" p-id="31281"></path>
                </svg>
              </div>
              <span>{{ $t('cover_info.t03') }}</span>
            </div>
            <!-- 证书 -->
            <!-- <div class="cover_info_item" @click="$router.push('/credential')">
              <div class="icon">
                <svg t="1778141692750" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="34118" style="width: .64rem;height: .64rem;"><path d="M835.072 1020.416H171.52c-46.08 0-82.944-37.376-82.944-82.944V88.576c0-46.08 37.376-82.944 82.944-82.944h663.552c46.08 0 82.944 37.376 82.944 82.944V936.96c0 46.08-36.864 83.456-82.944 83.456zM171.52 69.12c-10.24 0-19.456 8.704-19.456 19.456V936.96c0 10.24 8.704 19.456 19.456 19.456h663.552c10.24 0 19.456-8.704 19.456-19.456V88.576c0-10.24-8.704-19.456-19.456-19.456H171.52z" fill="#ffffff" p-id="34119"></path><path d="M348.672 177.664h308.736v64H348.672zM243.2 336.384h520.192v64H243.2zM243.2 490.496h520.192v64H243.2zM631.808 920.576c-76.8 0-139.776-62.464-139.776-139.776s62.464-139.776 139.776-139.776 139.776 62.464 139.776 139.776-62.976 139.776-139.776 139.776z m0-215.552c-41.984 0-75.776 33.792-75.776 75.776s33.792 75.776 75.776 75.776 75.776-33.792 75.776-75.776-34.304-75.776-75.776-75.776z" fill="#ffffff" p-id="34120"></path><path d="M599.552 748.544h64v64h-64zM244.736 748.544H399.36v64H244.736z" fill="#ffffff" p-id="34121"></path></svg>
              </div>
              <span>{{ $t('cover_info.t04') }}</span>
            </div> -->
          </div>
        </div>
      </div>

      <!-- <div class="wallet_info">
        <div class="wallet_info_con">
          <div class="l">
            <p>${{ userInfo?.balance }}</p>
            <span>{{ $t('cont.t06') }}</span>
          </div>
          <div class="r" @click="$router.push('/recharge')">
            <svg t="1748488419325" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="33877" width=".64rem">
              <path
                d="M503.466667 465.066667c-96.853333-25.173333-128-50.986667-128-91.52 0-46.506667 42.88-79.146667 115.2-79.146667 75.946667 0 104.106667 36.266667 106.666666 89.6h94.293334c-2.773333-73.6-47.786667-140.586667-136.96-162.56V128h-128v92.16c-82.773333 18.133333-149.333333 71.466667-149.333334 154.026667 0 98.56 81.706667 147.626667 200.533334 176.213333 106.88 25.6 128 62.933333 128 103.04 0 29.226667-20.693333 76.16-115.2 76.16-87.893333 0-122.666667-39.466667-127.146667-89.6h-94.08c5.333333 93.44 75.093333 145.706667 157.226667 163.413333V896h128v-91.733333c82.986667-16 149.333333-64 149.333333-151.68 0-120.746667-103.68-162.133333-200.533333-187.52z"
                p-id="33878" fill="#000"></path>
            </svg>
          </div>
        </div>
      </div> -->

      <!-- <div class="contain">
        <iframe
          src="https://open.spotify.com/embed/playlist/37i9dQZEVXbNG2KDcFcKOF?utm_source=generator%22&theme=0"></iframe>
      </div> -->

      <div class="contain">
        <p class="contain_title">{{ $t('movie.t01') }}</p>
        <div class="contain_con">
          <div class="contain_con_item" v-for="(item, index) in homeData.goods" :key="index" @click="containFun(item)">
            <img :src="item.goods_pic" alt="">
          </div>
        </div>
      </div>
      <van-overlay :show="movieShow" @click="movieShow = false" z-index="999">
        <div class="containOverlay_view" @click.stop>
          <div class="cost" @click="movieShow = false">×</div>
          <div class="overlay_view_con">
            <img :src="containInfo.goods_pic" alt="">
            <div class="overlay_view_con_r">
              <p class="goods_name">{{ containInfo.goods_name }}</p>
              <p class="synopsis">{{ containInfo.synopsis }}</p>
            </div>
          </div>
          <div class="overlay_view_bottom">
            <div class="btn" @click="movieShow = false; $router.push('/goOrder')">
              <van-icon name="share-o" color="#fff" size=".5rem" />
            </div>
          </div>
        </div>
      </van-overlay>
      <div>
        <van-overlay :show="show" @click="show = false" z-index="999">
          <div class="overlay_view" @click.stop>
            <div class="cost" @click="show = false">×</div>
            <div class="overlay_view_top">
              <!-- <img src="@/assets/image/sscsscs_header.png" alt=""> -->
              <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 22" role="presentation" focusable="false"
                width="170">
                <path fill-rule="nonzero" fill="#fff"
                  d="M81.95 7.43c3.59 0 5.77 2.33 6.02 5.1h-2.72a3.17 3.17 0 00-3.28-2.7c-2.2 0-3.66 1.86-3.66 4.88 0 3.08 1.47 4.87 3.7 4.87 1.75 0 2.9-.97 3.24-2.6H88c-.3 3-2.68 5.02-6.03 5.02-3.98 0-6.58-2.75-6.58-7.29 0-4.46 2.6-7.28 6.56-7.28zm-19.61 0c3.24 0 5.35 1.82 5.44 4.41h-2.69c-.16-1.36-1.15-2.22-2.75-2.22-1.55 0-2.59.77-2.59 1.89 0 .88.64 1.48 2.15 1.83l2.26.52c2.85.66 3.94 1.79 3.94 3.81 0 2.57-2.37 4.33-5.66 4.33-3.48 0-5.57-1.72-5.84-4.4h2.84c.26 1.48 1.25 2.2 3 2.2 1.72 0 2.78-.72 2.78-1.87 0-.91-.51-1.44-2.04-1.8l-2.26-.52c-2.65-.62-3.96-1.9-3.96-3.94 0-2.51 2.17-4.24 5.38-4.24zm-17 .26v8.53c0 2.14 1.01 3.28 2.99 3.28 2.06 0 3.3-1.44 3.3-3.63V7.7h2.87v14.04h-2.74v-2.37h-.07c-.77 1.68-2.19 2.63-4.32 2.63-3.03 0-4.88-2-4.88-5.21v-9.1h2.86zm-33.1-1.65h.3c.66.06 2.57.27 3.79 2.09-.1.08-2.27 1.33-2.24 3.98.02 3.16 2.75 4.21 2.77 4.24-.02.07-.43 1.49-1.42 2.95-.87 1.28-1.76 2.54-3.18 2.57-1.38.02-1.84-.82-3.42-.82-1.58 0-2.08.8-3.38.84-1.38.05-2.42-1.36-3.29-2.64C.4 16.65-.96 11.93.87 8.75c.9-1.6 2.53-2.6 4.28-2.63 1.35-.02 2.6.9 3.41.9.82 0 2.27-1.07 3.98-.97zm11.41-3.57l6.19 15.35h.1l6.18-15.35h3.44v19.26h-2.71V7.56h-.1L31 21.73h-2.2L23.02 7.56h-.1v14.17h-2.7V2.47h3.43zm49.52 5.22v14.04H70.3V7.7h2.86zM12.55 1a4.72 4.72 0 01-1.07 3.35c-.74.87-1.92 1.57-3.1 1.47a4.42 4.42 0 011.1-3.22A4.6 4.6 0 0112.56 1zm59.19 1.32c.91 0 1.64.74 1.64 1.66a1.65 1.65 0 11-3.3 0c0-.92.74-1.66 1.66-1.66z">
                </path>
              </svg> -->
              <img src="../assets/image/Logo.svg" alt="">
            </div>
            <div class="overlay_view_con">
              <div v-html="homeData.notice"></div>
            </div>
            <div class="overlay_view_bottom">
              <div class="btn" @click="show = false">ok</div>
            </div>
          </div>
        </van-overlay>
      </div>
    </div>
  </div>
</template>
<script>
import navs from "@/components/navs.vue";
import { SERVERTAPI } from '@/config'
import { mapState } from "vuex";

export default {
  components: {
    navs
  },
  data() {
    return {
      show: false,
      movieShow: false,
      containInfo:
      {
        "id": 2617,
        "goods_info": null,
        "goods_pic": "https://resizing.flixster.com/tJbu1V24LBaxMm-NhK-Dgbk2D_0=/206x305/v2/https://resizing.flixster.com/Oul4sVGBQ0SHLHJofOX9j_59RWU=/ems.cHJkLWVtcy1hc3NldHMvbW92aWVzL2E2YzNmYWNhLWQwMTgtNGI5My1iMjBiLTIzZDQ4YzQ3YTdlMi5qcGc=",
        "goods_name": "The Secrets We Bury",
        "shop_name": null,
        "status": 1,
        "cid": 1,
        "goods_price": "0.00",
        "addtime": 1627909649,
        "paixu": 0,
        "mediaUrl": "https://www.rottentomatoes.com/m/the_secrets_we_bury",
        "releaseDateText": "Streaming Dec 16, 2025",
        "detailTitle": "The Secrets We Bury",
        "cast": "[\"Patricia E. Gillespie\", \"Jessica Horowitz\", \"Liz Massie\", \"James Buddy Day\", \"Linsey Romero\"]",
        "release_date": "2025-12-16",
        "rating": null,
        "synopsis": "In the early 1960s, George Carroll walked out on his family, leaving his wife, Dorothy, and their four children behind. Decades later, the Carroll siblings are still left haunted by what happened to their father. Seeking much-needed closure for himself an",
        "detailJson": "{\"title\": \"The Secrets We Bury\", \"cast\": [\"Patricia E. Gillespie\", \"Jessica Horowitz\", \"Liz Massie\", \"James Buddy Day\", \"Linsey Romero\"], \"release_date\": \"2025-12-16\", \"rating\": null, \"synopsis\": \"In the early 1960s, George Carroll walked out on his family, leaving his wife, Dorothy, and their four children behind. Decades later, the Carroll siblings are still left haunted by what happened to their father. Seeking much-needed closure for himself and his family, THE SECRETS WE BURY follows Mike Carroll as he unravels the mystery of his father's disappearance and uncovers a story much darker and more complex than his family could have imagined. Told through extensive sit-down interviews with the Carroll siblings and layered with intimate archival footage of the Carroll family spanning decades of their lives, the documentary offers a sensitive look into one family's journey to find closure. Part mystery and part family drama, THE SECRETS WE BURY raises important questions about whose stories we choose to believe, and why.\"}"
      }
      ,
      apiSrc: SERVERTAPI,
      cover_info: [
        {
          title: this.$t('cover_info.t01'),
          desc: 'touch_app',
          to: '/goOrder'
        },
        {
          title: this.$t('cover_info.t02'),
          desc: 'paid',
          to: '/recharge'
        },
        {
          title: this.$t('cover_info.t03'),
          desc: 'wallet',
          to: '/withdraw'
        },
        {
          title: this.$t('cover_info.t04'),
          desc: 'security',
          to: '/credential'
        }
      ],
      homeData: {},
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      musicList: [
        {
          imgSrc: require('@/assets/musicIcon/icon01.webp'),
          text1: 'NOKIA',
          text2: 'Drake',
          time: '4:01'
        },
        {
          imgSrc: require('@/assets/musicIcon/icon02.webp'),
          text1: 'luther',
          text2: 'Kendrick Lamar, SZA',
          time: '2:57'
        },
        {
          imgSrc: require('@/assets/musicIcon/icon03.webp'),
          text1: 'Die With A Smile',
          text2: 'Lady Gaga, Bruno Mars',
          time: '4:11'
        }, {
          imgSrc: require('@/assets/musicIcon/icon04.webp'),
          text1: 'Not Like Us',
          text2: 'Kendrick Lamar',
          time: '4:34'
        }, {
          imgSrc: require('@/assets/musicIcon/icon05.webp'),
          text1: 'Just In Case',
          text2: 'Morgan Wallen',
          time: '2:46'
        }, {
          imgSrc: require('@/assets/musicIcon/icon06.webp'),
          text1: 'APT.',
          text2: '로제, Bruno Mars',
          time: '2:49'
        }, {
          imgSrc: require('@/assets/musicIcon/icon07.webp'),
          text1: 'twilight zone',
          text2: 'Ariana Grande',
          time: '3:18'
        }, {
          imgSrc: require('@/assets/musicIcon/icon08.webp'),
          text1: 'Ordinary',
          text2: 'Alex Warren',
          time: '3:06'
        }, {
          imgSrc: require('@/assets/musicIcon/icon09.webp'),
          text1: "I'm The Problem",
          text2: 'Morgan Wallen',
          time: '2:57'
        }, {
          imgSrc: require('@/assets/musicIcon/icon10.webp'),
          text1: '30 For 30 (with Kendrick Lamar)',
          text2: 'SZA',
          time: '4:38'
        },

      ]
    }
  },
  created() {
    this.$store.commit('SET_LOADING', true);
    this.$http.getHomeIndex().then(res => {
      if (res.code === 0) {
        this.homeData = res.data;
      } else {
        // this.$toast(res.info);
      }
    }).finally(() => {
      this.$store.commit('SET_LOADING', false);
    })
    // 获取用户信息
    // if (!localStorage.getItem('userInfo')) {

    // }
    this.$http.getmyindex().then(res => {
      if (res.code !== -1) {
        this.userInfo = res.data?.info;
      }
    });
    // 获取弹窗状态
    setTimeout(() => {
      this.show = this.newLogin;
      // 存入弹窗状态
      this.$store.commit('SET_NEW_LOGIN', false);
    }, 500)
  },
  mounted() {
  },
  destroyed() {
  },
  computed: {
    // 获取弹窗状态
    ...mapState(['newLogin'])
  },
  methods: {
    assetUrl(url) {
      if (!url) return "";
      if (/^(https?:)?\/\//i.test(url) || /^data:/i.test(url) || /^blob:/i.test(url)) return url;
      const base = (this.apiSrc || "").replace(/\/+$/, "");
      const path = String(url).replace(/^\/+/, "");
      if (!base) return `/${path}`;
      return `${base}/${path}`;
    },
    // toMusicLink() {
    //   window.open('https://music.apple.com/kr/playlist/%EC%98%A4%EB%8A%98%EC%9D%98-top-100-%EA%B8%80%EB%A1%9C%EB%B2%8C/pl.d25f5d1181894928af76c85c967f8f31', '_blank')
    // },
    containFun(item) {
      this.containInfo = item;
      this.movieShow = true;
      console.log(item);



      // {
      // "id": 2617,
      // "goods_info": null,
      // "goods_pic": "https://resizing.flixster.com/tJbu1V24LBaxMm-NhK-Dgbk2D_0=/206x305/v2/https://resizing.flixster.com/Oul4sVGBQ0SHLHJofOX9j_59RWU=/ems.cHJkLWVtcy1hc3NldHMvbW92aWVzL2E2YzNmYWNhLWQwMTgtNGI5My1iMjBiLTIzZDQ4YzQ3YTdlMi5qcGc=",
      // "goods_name": "The Secrets We Bury",
      // "shop_name": null,
      // "status": 1,
      // "cid": 1,
      // "goods_price": "0.00",
      // "addtime": 1627909649,
      // "paixu": 0,
      // "mediaUrl": "https://www.rottentomatoes.com/m/the_secrets_we_bury",
      // "releaseDateText": "Streaming Dec 16, 2025",
      // "detailTitle": "The Secrets We Bury",
      // "cast": "[\"Patricia E. Gillespie\", \"Jessica Horowitz\", \"Liz Massie\", \"James Buddy Day\", \"Linsey Romero\"]",
      // "release_date": "2025-12-16",
      // "rating": null,
      // "synopsis": "In the early 1960s, George Carroll walked out on his family, leaving his wife, Dorothy, and their four children behind. Decades later, the Carroll siblings are still left haunted by what happened to their father. Seeking much-needed closure for himself an",
      // "detailJson": "{\"title\": \"The Secrets We Bury\", \"cast\": [\"Patricia E. Gillespie\", \"Jessica Horowitz\", \"Liz Massie\", \"James Buddy Day\", \"Linsey Romero\"], \"release_date\": \"2025-12-16\", \"rating\": null, \"synopsis\": \"In the early 1960s, George Carroll walked out on his family, leaving his wife, Dorothy, and their four children behind. Decades later, the Carroll siblings are still left haunted by what happened to their father. Seeking much-needed closure for himself and his family, THE SECRETS WE BURY follows Mike Carroll as he unravels the mystery of his father's disappearance and uncovers a story much darker and more complex than his family could have imagined. Told through extensive sit-down interviews with the Carroll siblings and layered with intimate archival footage of the Carroll family spanning decades of their lives, the documentary offers a sensitive look into one family's journey to find closure. Part mystery and part family drama, THE SECRETS WE BURY raises important questions about whose stories we choose to believe, and why.\"}"
      // }
    }
  },
}
</script>
<style lang='less' scoped>
.material-icons {
  color: #fff;
  font-size: .64rem;
}

.home {
  min-height: 100vh;

  .swipe {
    img {
      width: 100%;
      height: 7rem;
      object-fit: cover;
    }

    .cover_info {
      width: 100%;
      background-color: #282828;
      border-radius: .26rem;
      padding: .26rem 0;
      display: flex;
      justify-content: space-around;
      margin-top: -1.3rem;
      position: relative;
      z-index: 9;

      .cover_info_item {
        flex: 1;
        display: flex;
        flex-direction: column;
        //padding: 0 .4rem;
        max-width: 2.6rem;
        gap: .2rem;
        justify-content: flex-start;
        align-items: center;
        text-align: center;

        .icon {
          width: 1.3rem;
          height: 1.3rem;
          background-color: #121212;
          border-radius: .2rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        span {
          font-size: .3rem;
          color: #fff;
        }
      }
    }
  }

  .wallet_info {
    width: 100%;
    padding: 0 .4rem;
    margin: .64rem auto;

    .wallet_info_con {
      display: flex;
      color: #fff;
      justify-content: space-between;
      background-color: #333;
      border-radius: .26rem;
      padding: .4rem;

      .l {
        display: flex;
        flex-direction: column;

        p {
          font-size: .7rem;
        }

        span {
          font-size: .36rem;
          opacity: .7;
        }
      }

      .r {
        width: 1.44rem;
        height: 1.44rem;
        background-color: #fff;
        border-radius: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          color: #000;
          font-size: .64rem;
        }
      }
    }
  }

  // .contain {
  //   width: 100%;
  //   height: 14rem;
  //   margin-bottom: 2rem;
  //   padding: 0 .4rem;
  //   background-color: #121212;

  //   iframe {
  //     width: 100%;
  //     height: 100%;
  //     border: none;
  //     padding: 0;
  //   }
  // }
  .contain {
    padding: 0 .3rem;
    color: #D9D9DB;
    margin-top: .6rem;

    p.contain_title {
      font-weight: 700;
      font-size: .4rem;
    }

    .contain_con {
      padding: .3rem 0 3rem 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .contain_con_item {
        width: 47%;
        aspect-ratio: 1 / 1.4;
        background-color: #121212;
        margin-bottom: .3rem;
        border-radius: .2rem;
        overflow: hidden;
        border: .08rem solid #333;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  // 弹窗
  .containOverlay_view {
    border-top-left-radius: .1rem;
    border-top-right-radius: .1rem;
    border-bottom-right-radius: .2rem;
    border-bottom-left-radius: .2rem;
    //overflow: hidden;
    width: 80%;
    //height: 10rem;
    background-color: #fff;
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .overlay_view_top {
      display: flex;
      justify-content: center;
      padding: .4rem 1rem;

      img {
        height: 100%;
      }

      height: 2.2rem;
      background-color: #121212;
    }

    .overlay_view_con {
      border-top-left-radius: .1rem;
      border-top-right-radius: .1rem;
      padding: .64rem .4rem .4rem;
      font-size: .37rem;
      color: #333;
      text-align: center;
      background-color: #F5F5F5;
      display: flex;
      gap: .2rem;

      img {
        width: 40%;
        border-radius: .2rem;
      }

      .overlay_view_con_r {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        p.goods_name {
          font-size: .42rem;
          font-weight: 700;
        }

        p.synopsis {
          text-align: left;
          font-size: .3rem;
          font-weight: 700;
          line-height: .3rem;
          margin-top: .2rem;
        }
      }
    }

    .overlay_view_bottom {
      border-top: #F5F5F5 solid .1rem;
      padding: .3rem;

      .btn {
        padding: .3rem;
        color: #fff;
        background-color: #121212;
        font-size: .37rem;
        border-radius: 2rem;
        text-align: center;
      }
    }

  }
}

::v-deep {
  #__next {
    background-color: #D44246;
  }
}

.overlay_view {
  border-top-left-radius: .1rem;
  border-top-right-radius: .1rem;
  border-bottom-right-radius: .2rem;
  border-bottom-left-radius: .2rem;
  //overflow: hidden;
  width: 80%;
  max-width: 500px;
  //height: 10rem;
  background-color: #fff;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .overlay_view_top {
    display: flex;
    justify-content: center;
    padding: .4rem 1rem;

    img {
      height: 100%;
    }

    height: 2.2rem;
    background-color: #121212;
  }

  .overlay_view_con {
    padding: .64rem .4rem .4rem;
    font-size: .37rem;
    color: #333;
    text-align: center;
  }

  .overlay_view_bottom {
    border-top: #F5F5F5 solid .1rem;
    padding: .3rem;

    .btn {
      padding: .3rem;
      color: #fff;
      background-color: #121212;
      font-size: .37rem;
      border-radius: 2rem;
      text-align: center;
    }
  }

}

.cost {
  position: absolute;
  top: -.2rem;
  right: -.2rem;
  background-color: #fff;
  border-radius: 1rem;
  width: .6rem;
  height: .6rem;
  font-size: .6rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep {
  .van-overlay {
    background-color: rgba(0, 0, 0, .4);
  }
}
</style>
